/*
 * Wishlist (botón de favoritos en las tarjetas de producto).
 *
 * Antes esta lógica vivía DENTRO de snippets/wishlist-float-button.liquid, que se
 * renderiza una vez POR TARJETA → el mismo <script> de 6.8KB se repetía 46 veces en
 * el home (~312KB de HTML duplicado) + el <style> otras 46 veces. Ahora vive acá:
 * se descarga una vez, se cachea entre páginas y el snippet solo emite el botón.
 *
 * Los datos del cliente (id + wishlist actual) los inyecta theme.liquid con Liquid
 * en un inline mínimo, ANTES de este archivo:
 *   window.__TT_WISHLIST_CUSTOMER_ID, window.__TT_WISHLIST_RAW
 */
(function () {
  window.TT_WISHLIST_CONFIG = window.TT_WISHLIST_CONFIG || {
    endpoint: 'https://gajloi5an7.execute-api.us-east-1.amazonaws.com/wishlist'
  };

  function ttWishlistNormalize(raw) {
    if (!raw) return [];

    if (Array.isArray(raw)) {
      return raw
        .map(function (item) {
          if (item == null) return '';
          if (typeof item === 'object') {
            return String(item.sku || item.code || item.id || '').trim();
          }
          return String(item).trim();
        })
        .filter(Boolean);
    }

    if (typeof raw === 'string') {
      try {
        return ttWishlistNormalize(JSON.parse(raw));
      } catch (e) {
        return raw.split(',').map(function (item) {
          return item.trim();
        }).filter(Boolean);
      }
    }

    if (typeof raw === 'object') {
      if (Array.isArray(raw.skus)) return ttWishlistNormalize(raw.skus);
      if (Array.isArray(raw.items)) return ttWishlistNormalize(raw.items);
    }

    return [];
  }

  if (!window.__TTWishlistState) {
    window.__TTWishlistState = {
      customerId: window.__TT_WISHLIST_CUSTOMER_ID || null,
      skus: new Set(ttWishlistNormalize(window.__TT_WISHLIST_RAW))
    };
  }

  function setButtonState(button, isActive, isLoading) {
    button.classList.toggle('is-active', !!isActive);
    button.classList.toggle('is-loading', !!isLoading);
    button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    button.setAttribute('aria-label', isActive ? 'Producto en favoritos' : 'Agregar a favoritos');
  }

  function syncWishlistButtons(scope) {
    var root = scope || document;
    var buttons = root.querySelectorAll('[data-wishlist-button]');

    buttons.forEach(function (button) {
      var sku = button.dataset.sku || '';
      var isActive = window.__TTWishlistState.skus.has(sku);
      setButtonState(button, isActive, false);
    });
  }

  async function addToWishlist(customerId, sku) {
    var response = await fetch(window.TT_WISHLIST_CONFIG.endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-secret': 'ScirlQW1DyRF2pp38o2LrKSJSw9Gp1bM1BsZyYFa1PPzqbMMZkXZUGpSjFGZwEOI'
      },
      body: JSON.stringify({
        customerId: customerId,
        skus: [sku]
      })
    });

    if (!response.ok) {
      var errorText = await response.text();
      throw new Error(errorText || 'No se pudo agregar a wishlist');
    }

    try {
      return await response.json();
    } catch (e) {
      return await response.text();
    }
  }

  function stopCardNavigation(event) {
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
  }

  /*
   * Posiciona el corazón contra el borde de la IMAGEN (no del <a>, que puede ser
   * más alto que la foto).
   *
   * OJO — INP: la versión anterior alternaba LEER y ESCRIBIR dentro del forEach
   * (getComputedStyle → style.position → getBoundingClientRect → style.right…).
   * Cada escritura invalida el layout, así que el getBoundingClientRect de la
   * vuelta siguiente forzaba un reflow: con 46 tarjetas = 46 reflows forzados.
   * Lighthouse lo marcaba en "Reprocesamiento forzado".
   *
   * Ahora va en dos fases: primero se LEE todo (un solo reflow) y después se
   * ESCRIBE todo. También se sacó el getComputedStyle: el <a> ya trae
   * style="position:relative" desde product-grid-item.liquid, y re-aplicarlo es
   * inofensivo y no obliga a leer estilos calculados.
   */
  function positionWishlistInsideImage(scope) {
    var roots = (scope || document).querySelectorAll('[data-wishlist-root]');
    if (!roots.length) return;

    // --- FASE 1: solo lecturas ---
    var jobs = [];
    roots.forEach(function (root) {
      var anchor = root.closest('.productitem--image-link');
      if (!anchor) return;
      var figure = anchor.querySelector('.productitem--image');
      if (!figure) return;

      var anchorRect = anchor.getBoundingClientRect();
      var figureRect = figure.getBoundingClientRect();

      jobs.push({
        root: root,
        anchor: anchor,
        right: anchorRect.right - figureRect.right + 10,
        bottom: anchorRect.bottom - figureRect.bottom + 10
      });
    });

    // --- FASE 2: solo escrituras ---
    jobs.forEach(function (j) {
      if (j.anchor.style.position !== 'relative') j.anchor.style.position = 'relative';
      var s = j.root.style;
      s.position = 'absolute';
      s.top = 'auto';
      s.left = 'auto';
      s.right = j.right + 'px';
      s.bottom = j.bottom + 'px';
      s.zIndex = '35';
    });
  }

  function bindWishlistButtons(scope) {
    var root = scope || document;
    var buttons = root.querySelectorAll('[data-wishlist-button]');

    buttons.forEach(function (button) {
      if (button.dataset.ttWishlistBound === 'true') return;
      button.dataset.ttWishlistBound = 'true';

      ['pointerdown', 'mousedown', 'touchstart'].forEach(function (type) {
        button.addEventListener(type, stopCardNavigation, true);
      });

      button.addEventListener('click', async function (event) {
        stopCardNavigation(event);

        var customerId = button.dataset.customerId || window.__TTWishlistState.customerId;
        var sku = button.dataset.sku || '';

        if (!customerId) {
          var returnUrl = window.location.pathname + window.location.search + window.location.hash;
          window.location.href = '/account/login?return_url=' + encodeURIComponent(returnUrl);
          return;
        }

        if (!sku) return;
        if (button.classList.contains('is-loading')) return;
        if (window.__TTWishlistState.skus.has(sku)) return;

        setButtonState(button, true, true);

        try {
          await addToWishlist(customerId, sku);
          window.__TTWishlistState.skus.add(sku);
          syncWishlistButtons(document);
        } catch (error) {
          console.error('Wishlist error:', error);
          setButtonState(button, false, false);
        }
      }, true);
    });
  }

  function initWishlist(scope) {
    bindWishlistButtons(scope);
    syncWishlistButtons(scope);
    positionWishlistInsideImage(scope);
  }

  if (!window.__TTWishlistDomReady) {
    window.__TTWishlistDomReady = true;

    document.addEventListener('DOMContentLoaded', function () {
      initWishlist(document);
    });

    window.addEventListener('load', function () {
      positionWishlistInsideImage(document);
    });

    /* resize CON debounce: antes reposicionaba las 46 tarjetas en CADA píxel
       de redimensionado (y al rotar el celular), machacando el hilo principal. */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        positionWishlistInsideImage(document);
      }, 150);
    }, { passive: true });

    document.addEventListener('shopify:section:load', function (event) {
      initWishlist(event.target || document);
    });

    /* MutationObserver acotado: antes escuchaba TODO el documento y, ante
       cualquier cambio del DOM (el carrusel moviéndose, un menú, una app
       inyectando algo), re-inicializaba y reposicionaba las 46 tarjetas.
       Ahora solo reacciona si lo agregado contiene botones de wishlist, y
       agrupa el trabajo en un rAF para no hacerlo N veces por lote. */
    var pending = null;
    function scheduleInit() {
      if (pending) return;
      pending = requestAnimationFrame(function () {
        pending = null;
        initWishlist(document);
      });
    }

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (node.nodeType !== 1) continue;
          if (
            (node.matches && node.matches('[data-wishlist-root], [data-wishlist-button]')) ||
            (node.querySelector && node.querySelector('[data-wishlist-root], [data-wishlist-button]'))
          ) {
            scheduleInit();
            return;
          }
        }
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  initWishlist(document);
})();
